import CachedIcon from '@mui/icons-material/Cached';
import EditIcon from '@mui/icons-material/Edit';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { Card, CardContent, CardHeader, IconButton, Typography } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import * as React from "react";
import { connect } from "react-redux";
import { ExcessHeavyLeakageCurrentModel, UpdateResult } from '../../../models';
import { ApplicationState, FetchState, actionCreators, selectors } from "../../../store";
import { showUnit } from '../../../utils';
import FetchHelper from '../../FetchHelper';
import SelectExcessHeavyLeakageCurrentDialog from '../../dialogs/SelectExcessHeavyLeakageCurrentDialog';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';

const NO_OF_POLLING_TOPIC = 11;
const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    loadingRefreshAll: [false],
    isEdit: false,
    isRefreshGroup: false,
    isDisbleRefeshBtn: true,
    isDisbleUpdateBtn: true,
    isRefreshAllCompleted: (status: number) => { },
    setIsEdit: (isEdit: boolean) => { },
    setRefreshGroup: (disabled: boolean, name: string) => { },
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
}

const fetchId = "EXCESS_HEAVY_LEAKAGE_CURRENT_FETCH";

type ExcessHeavyLeakageCurrentProps = {
    defaultData: ExcessHeavyLeakageCurrentModel | undefined;
    deviceNo?: string;
    centralId?: string;
    isRefreshSuccessDeviceNo?: boolean;
    onRefreshComplete?: () => void;
};

export type PureExcessHeavyLeakageCurrentProps = ExcessHeavyLeakageCurrentProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

export const ExcessHeavyLeakageCurrent_TJ360VersionDevice = (props: PureExcessHeavyLeakageCurrentProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isEdit, isRefreshGroup, isDisbleRefeshBtn, isDisbleUpdateBtn, deviceNo, centralId, isRefreshSuccessDeviceNo } = props;
    const { onError, onUpdate, onRefresh, onUpdateSuccess, onUpdateError, isRefreshAllCompleted, setIsEdit, setRefreshGroup, setDisabledRefreshGroupBtn } = props;
    const [openSelectDialog, setOpenSelectDialog] = React.useState(false);
    const [updateData, setUpdateData] = React.useState<any>();
    const [excessHeavyLeakageCurrent, setExcessHeavyLeakageCurrent] = React.useState<ExcessHeavyLeakageCurrentModel | null>(fetchState.data);
    const [editData, setEditData] = React.useState<ExcessHeavyLeakageCurrentModel>();
    const [fetchLoading, setFetchLoading] = React.useState(false);
    const [editFlg, setEditFlg] = React.useState(false);
    const [isFetchAll, setIsFetchAll] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);

    React.useEffect(() => {
        if(!isRefreshSuccessDeviceNo)
            setIsRefreshSuccess(false);
    }, [isRefreshSuccessDeviceNo]);

    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "QC";
        params.set("code", code);
        params.set("mainid", mainid);
        params.set("device_no", deviceNo);
        params.set("centralid", centralId);
        return params;
    }

    const handleFetchSuccess = (data: any, action: string, isClickedRefreshBtn: boolean) => {
        const resData = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            limitOverSec1: data.limit_over_sec1,
            recoverySec1: data.recovery_sec1,
            limitOverSec2: data.limit_over_sec2,
            recoverySec2: data.recovery_sec2,
            limitOverSec3: data.limit_over_sec3,
            recoverySec3: data.recovery_sec3,
            limitOverSec4: data.limit_over_sec4,
            recoverySec4: data.recovery_sec4,
            limitOverSec5: data.limit_over_sec5,
            recoverySec5: data.recovery_sec5,
            limitOverSec6: data.limit_over_sec6,
            recoverySec6: data.recovery_sec6,
            lastGetDatetime: data.last_get_datetime,
        } as ExcessHeavyLeakageCurrentModel;

        setExcessHeavyLeakageCurrent(resData);
        setFetchLoading(false);
        setIsFetchAll(false);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);

        if (action === 'edit') {
            setEditData(resData);
            setEditFlg(false);
            setOpenSelectDialog(true);
        }
    };

    const handleError = (success: boolean, data: any, error: any) => {
        onError(success, data, error);
        setEditFlg(false);
        setFetchLoading(false);
        setIsFetchAll(false);
        setIsRefreshSuccess(false);
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
    }

    const handleRefresh = () => {
        setFetchLoading(true);
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params, fetchId + deviceNo);
    };

    const handleRefreshSuccess = (data: any) => {
        editFlg ? handleFetchSuccess(data, 'edit', true) : handleFetchSuccess(data, 'view', true);
        props.onRefreshComplete?.();
    }

    const [updateDialogTitle, setUpdateDialogTitle] = React.useState('');
    const handleEdit = () => {
        setEditFlg(true);
        const params = handleFetchParams();
        onRefresh(params, fetchId + deviceNo);
        setUpdateDialogTitle(`重漏電流超過・復帰時間`);
        setFetchLoading(true);
        setIsRefreshSuccess(false);
    };

    const handleUpdateEquipmentOk = (request: any) => {
        setOpenSelectDialog(false);
        const code = "QD";
        const requestData = {
            mainid: request.mainid,
            device_no: request.device_no,
            centralid: centralId,
            limit_over_sec1: request.limit_over_sec1,
            recovery_sec1: request.recovery_sec1,
            limit_over_sec2: request.limit_over_sec2,
            recovery_sec2: request.recovery_sec2,
            limit_over_sec3: request.limit_over_sec3,
            recovery_sec3: request.recovery_sec3,
            limit_over_sec4: request.limit_over_sec4,
            recovery_sec4: request.recovery_sec4,
            limit_over_sec5: request.limit_over_sec5,
            recovery_sec5: request.recovery_sec5,
            limit_over_sec6: request.limit_over_sec6,
            recovery_sec6: request.recovery_sec6,
        }
        onUpdate(code, mainid, requestData);
        setUpdateData(request);
        setFetchLoading(true);
        setIsRefreshSuccess(false);
    };

    const handleUpdateEquipmentCancel = () => {
        setOpenSelectDialog(false);
        setEditFlg(false);
    };

    const handleUpdateSuccess = (success: boolean, data: any, error: any) => {
        const result = {
            mainid: data.mainid,
            deviceNo: data.device_no,
            resultCode: data.result_code,
        } as UpdateResult;
        if (result.resultCode === '0') {
            handleFetchSuccess(updateData, 'view', true);
            onUpdateSuccess();
        } else {
            handleUpdateError(success, data, error);
        }
    }

    const handleUpdateError = (success: boolean, data: any, error: any) => {
        setFetchLoading(false);
        setIsRefreshSuccess(true);
        onUpdateError(success, data, error);
        setEditFlg(false);
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC || isRefreshGroup === true) {
            handleRefresh();
        }
        if (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) {
            setFetchLoading(true);
            setIsRefreshSuccess(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setIsFetchAll(true) : setIsFetchAll(false);
    }
    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, loadingRefreshAll, isRefreshGroup]);

    const handleDisabledRefreshAll = () => {
        if (!fetchLoading) {
            setDisabledRefreshGroupBtn(false, fetchId);
        } else {
            setDisabledRefreshGroupBtn(true, fetchId);
        }
    }
    // eslint-disable-next-line
    React.useEffect(handleDisabledRefreshAll, [fetchLoading]);

    React.useEffect(() => {
        editFlg ? setIsEdit(true) : setIsEdit(false);
        // eslint-disable-next-line
    }, [editFlg])

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, 'view', false);
        if(!defaultData) {
            setExcessHeavyLeakageCurrent(null);
        }
        // eslint-disable-next-line
    }, [defaultData]);

    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="edit" onClick={() => handleEdit()} disabled={isDisbleUpdateBtn || isEdit || fetchLoading || isFetchAll}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit === true || fetchLoading || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                            <IconButton aria-label="refresh" onClick={() => handleRefresh()} disabled={isDisbleRefeshBtn || editFlg || fetchLoading || isFetchAll}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || editFlg === true || fetchLoading || isFetchAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title={`重漏電流超過・復帰時間`}
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0', minHeight: '200px' }}>
                    {fetchLoading ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>超過時間1</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>復帰時間1</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>超過時間2</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>復帰時間2</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>超過時間3</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>復帰時間3</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>超過時間4</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>復帰時間4</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>超過時間5</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>復帰時間5</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>超過時間6</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>復帰時間6</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>超過時間1</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.limitOverSec1}{showUnit(excessHeavyLeakageCurrent?.limitOverSec1, "s")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>復帰時間1</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.recoverySec1}{showUnit(excessHeavyLeakageCurrent?.recoverySec1, "s")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>超過時間2</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.limitOverSec2}{showUnit(excessHeavyLeakageCurrent?.limitOverSec2, "s")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>復帰時間2</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.recoverySec2}{showUnit(excessHeavyLeakageCurrent?.recoverySec2, "s")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>超過時間3</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.limitOverSec3}{showUnit(excessHeavyLeakageCurrent?.limitOverSec3, "s")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>復帰時間3</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.recoverySec3}{showUnit(excessHeavyLeakageCurrent?.recoverySec3, "s")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>超過時間4</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.limitOverSec4}{showUnit(excessHeavyLeakageCurrent?.limitOverSec4, "s")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>復帰時間4</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.recoverySec4}{showUnit(excessHeavyLeakageCurrent?.recoverySec4, "s")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>超過時間5</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.limitOverSec5}{showUnit(excessHeavyLeakageCurrent?.limitOverSec5, "s")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>復帰時間5</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.recoverySec5}{showUnit(excessHeavyLeakageCurrent?.recoverySec5, "s")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>超過時間6</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.limitOverSec6}{showUnit(excessHeavyLeakageCurrent?.limitOverSec6, "s")}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>復帰時間6</td>
                                    <td style={pollingColStyle}>{excessHeavyLeakageCurrent?.recoverySec6}{showUnit(excessHeavyLeakageCurrent?.recoverySec6, "s")}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{excessHeavyLeakageCurrent?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >

            {
                openSelectDialog ? (
                    <SelectExcessHeavyLeakageCurrentDialog
                        isOpen={true}
                        onOK={(data) => handleUpdateEquipmentOk(data)}
                        onCancel={handleUpdateEquipmentCancel}
                        data={editData}
                        dialogTitle={updateDialogTitle}
                    />
                ) : (
                    <div />
                )
            }
            <FetchHelper fetchId={fetchId + deviceNo} onComplete={(success, data, error) => success ? handleRefreshSuccess(data) : handleError(success, data, error)} />
            <FetchHelper fetchId="UPDATE_EXCESS_HEAVY_LEAKAGE_CURRENT" method="POST" onComplete={(success, data, error) => success ? handleUpdateSuccess(success, data, error) : handleUpdateError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onUpdate: (code: string, mainid: string, data: any) => actionCreators.fetch("UPDATE_EXCESS_HEAVY_LEAKAGE_CURRENT", `/polling-nrf/set?code=${code}`, 'POST', data, false, true),
    onRefresh: (params: any, fetchId: string) => actionCreators.fetch(fetchId, `/polling-nrf/get`, "GET", params),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: `重漏電流超過・復帰時間取得`,
            body: "重漏電流超過・復帰時間取得できませんでした。",
        }),
    onUpdateSuccess: () =>
        actionCreators.showMessage({
            type: "info",
            title: `重漏電流超過・復帰時間変更`,
            body: "重漏電流超過・復帰時間を変更しました。",
        }),
    onUpdateError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: `重漏電流超過・復帰時間変更`,
            body: "重漏電流超過・復帰時間を変更できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExcessHeavyLeakageCurrent_TJ360VersionDevice);
